import { Input, Label } from '@/components/basic';
import { IResource } from '@gettactic/api';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';

export interface ResourceMakeUnavailableControlProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  entity: string;
  resource: IResource | null;
}

export function ResourceMakeUnavailableControl<T extends FieldValues>({
  form,
  name,
  entity,
  resource
}: ResourceMakeUnavailableControlProps<T>) {
  return (
    <div className="mt-5 flex items-baseline gap-3 shadow-none">
      <Input
        type="checkbox"
        {...form.register(name)}
        id={`${entity}-is_unavailable`}
        aria-describedby={`description-${entity}-is_unavailable`}
        className="border border-tertiary shadow-none"
        //defaultChecked={defaultValues.is_unavailable}
      />
      <div>
        <Label
          htmlFor={`${entity}-is_unavailable`}
          className="relative -top-[0.25rem] cursor-pointer text-base font-bold text-red-900"
        >
          Make unavailable
        </Label>
        <p
          className="text-base font-normal text-red-800"
          id={`description-${entity}-is_approvable`}
        >
          {entity === 'zone' ? (
            <>
              When this box is checked, no new reservations can be made for
              workspaces belonging to {resource?.name || 'this zone'}.
            </>
          ) : (
            <>
              When this box is checked, no new reservations can be made for{' '}
              {resource?.name || 'this workspace'}.
            </>
          )}
        </p>
      </div>
    </div>
  );
}
